// extracted by mini-css-extract-plugin
var _1 = "ApplicantViewingCard-moduleactions__t4tuw";
var _2 = "ApplicantViewingCard-modulecontent__sQXSj";
var _3 = "ApplicantViewingCard-modulelabel__cSiY9";
var _4 = "ApplicantViewingCard-modulesummary__M9XBX";
export { _1 as "actions", _2 as "content", _3 as "label", _4 as "summary" }
